module.exports = __webpack_public_path__ + "img/template-slider-bg.3e2cf40f.png";